import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Input } from "ui";

import { VideoFormAtomProps } from "../VideoForm.types";

const DescriptionField = ({ control }: VideoFormAtomProps) => {
  const { t } = useTranslation();

  return (
    <Controller
      control={control}
      name="description"
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <Input
          value={value}
          onChange={onChange}
          label={t("Description")}
          placeholder={t("Enter Description")}
          errorMessage={error?.message}
          data-testid="video--description"
          asTag="textarea"
          maxLength={200}
        />
      )}
    />
  );
};

export default DescriptionField;
